<mat-card>
  <mat-card-header>
    <mat-card-title>Scheduled synchronization settings</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>Automatically check for updates in synchronized dictionaries.</p>
    <div class="sync-row">
      <mat-form-field>
        <mat-label>Check for updates</mat-label>
        <mat-select [(value)]="selectedInterval" (selectionChange)="onSelectionChange()">
          @for (interval of updateIntervals; track interval) {
            <mat-option [value]="interval.value">
              {{ interval.viewValue }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="sync-times">
        @if (selectedInterval > 0 && scheduledStatus?.lastRunTime?.length) {
          <div class="time">
            Last synchronization: {{ scheduledStatus?.lastRunTime | prettyDate }}
          </div>
        }
        @if (selectedInterval > 0 && scheduledStatus?.nextRunTime?.length) {
          <div class="time">
            Next synchronization: {{ scheduledStatus?.nextRunTime | prettyDate }}
          </div>
        }
      </div>
    </div>
    <div class="sync-action">
      @if (!isSyncing) {
        <button mat-raised-button color="primary"
          (click)="runSyncNow()">
          Run now
        </button>
      }
      @if (isSyncing) {
        <div class="sync-running">
          <mat-spinner diameter="20"></mat-spinner>
          <span>Synchronizing...</span>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
